import React from "react";
import ErrorMessage from "./ErrorMessage";

interface EmailInputProps {
  email: string;
  setEmail: (email: string) => void;
  setIsValid: (isValid: boolean) => void;
  text?: string;
  textError?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const EmailInput: React.FC<EmailInputProps> = ({
  email,
  setEmail,
  setIsValid,
  text = "Email Address",
  textError = "Invalid Email",
  onKeyDown,
  disabled,
}) => {
  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const isValid = validateEmail(newEmail);
    setIsValid(isValid);

    // console.log("Email nhập vào:", newEmail);
    // console.log("Email hợp lệ:", isValid);
  };

  return (
    <div className="input-container">
      <input
        style={{ height: 56, padding: "10px 16px" }}
        type="text"
        placeholder={text}
        value={email}
        onChange={handleEmailChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        className={email ? (validateEmail(email) ? "valid" : "invalid") : ""}
      />
      {email && !validateEmail(email) && textError && (
        <ErrorMessage message={textError} />
      )}
    </div>
  );
};

export default EmailInput;
